import UbicacionService from 'src/modules/ubicacion/ubicacionService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'UBICACION_VIEW';

const ubicacionViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: ubicacionViewActions.FIND_STARTED,
      });

      const record = await UbicacionService.find(id);

      dispatch({
        type: ubicacionViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: ubicacionViewActions.FIND_ERROR,
      });

      getHistory().push('/ubicacion');
    }
  },
};

export default ubicacionViewActions;
